// Translation file for English and Arabic
export const translations = {
  en: {
    // Common
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    upload: 'Upload',
    search: 'Search',
    actions: 'Actions',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    generate: 'Generate',
    filters: 'Filters',
    done: 'Done',
    profitMargin: 'Profit Margin',

    // Main Menu
    dashboard: 'Dashboard',
    ordersBoard: 'Orders Board',
    stockManagement: 'Stock Management',
    customersAndShipping: 'Customers & Shipping',
    settings: 'Settings',
    logout: 'Logout',
    leads: 'Leads',
    pendingWooOrders: 'Pending WooCommerce Orders',
    unmappedClickToMap: 'Unmapped - Click to map',
    ignored: 'Ignored',
    existingCrmCustomer: 'Existing CRM Customer',
    newCustomerLabel: 'New Customer',
    mapWooCommerceProduct: 'Map WooCommerce Product',
    selectCrmProductFor: 'Select the CRM product for:',
    typeToSearchCrmProducts: 'Type to search CRM products...',
    saveMapping: 'Save Mapping',
    ignoreItem: 'Ignore Item',
    importToCrm: 'Import to CRM',
    dismiss: 'Dismiss',
    noPendingWooOrders: 'No pending orders from WooCommerce.',
    newOrderFromWoo: 'New order from WooCommerce',

    // Orders Board
    deletedOrders: 'Deleted Orders',
    uploadOrders: 'Upload Orders',
    createNewOrder: 'Create New Order',
    newOrder: 'New Order',
    revenue: 'Revenue',
    orderId: 'Order ID',
    customer: 'Customer',
    location: 'Location',
    products: 'Products',
    total: 'Total',
    payment: 'Payment',
    shipping: 'Shipping',
    discount: 'Discount',

    // Order Status
    ordered: 'Ordered',
    shipped: 'Shipped',
    delivered: 'Delivered',
    completed: 'Completed',
    cancelled: 'Cancelled',
    returned: 'Returned',
    deleted: 'Deleted',

    // Order Actions
    moveToShipped: 'Move to Shipped',
    moveToOrdered: 'Move to Ordered',
    moveToDelivered: 'Move to Delivered',
    completeSale: 'Complete Sale',
    markReturned: 'Mark Returned',
    markCancelled: 'Mark Cancelled',
    reOrder: 'Re-Order',
    softDelete: 'Soft Delete',
    restoreToCancelled: 'Restore to Cancelled',
    permanentlyDelete: 'Permanently Delete',
    cancelOrder: 'Cancel Order',

    // Stock Management
    productsTab: 'Products',
    bottles: 'Bottles',
    oils: 'Oils',
    returnedPool: 'Returns',
    returnedProducts: 'Returns',
    vendors: 'Vendors',
    vendorManagement: 'Vendor Management',
    vendorName: 'Vendor Name',
    selectVendor: 'Select Vendor',
    adsLedger: 'Ads Ledger',
    addItem: 'Add Item',
    notifications: 'Notifications',
    uploadProducts: 'Upload Products',
    uploadBottles: 'Upload Bottles',
    uploadOils: 'Upload Oils',
    selectProduct: 'Select Product',
    addToReturned: 'Add to Returned',

    // Customers & Shipping
    customers: 'Customers',
    shippingFees: 'Shipping Fees',
    newCustomer: 'Add New',
    addCity: 'Add City',
    uploadCustomers: 'Upload Customers',
    uploadShipping: 'Upload Shipping',
    fees: 'Fees',
    searchCustomer: 'Search customer name or mobile...',
    clearSearch: 'Clear search',

    // Dashboard
    totalOrders: 'All Orders',
    topSellingProducts: 'Top Selling Products',
    lowStockAlert: 'Low Stock Alert',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    allTime: 'All Time',
    customRange: 'Custom Range',
    from: 'From',
    totalRevenue: 'Total Revenue',
    totalProfit: 'Total Profit',
    profitMargin: 'Profit Margin',
    successfulOrders: 'Successful Orders',
    activeOrders: 'Active Orders',
    completedVisa: '(Completed + Visa)',
    shippedRevenue: 'Shipped Revenue',
    costOfGoods: 'Cost of Goods',
    soldCompleted: 'Sold/Completed',
    adsSpend: 'Ads Spend',
    addAdsSpend: 'Add Ads Spend',
    grossProfit: 'Gross Profit',
    profitAfterAds: 'Profit After Ads',
    lowStockAlerts: 'Low Stock Alerts',
    noLowStockAlerts: 'No low stock alerts!',
    netRevenue: 'Monthly Revenue',

    // View Modes
    auto: 'Auto',
    table: 'Table',
    cards: 'Cards',

    // Additional UI
    to: 'to',
    orders: 'Orders',
    more: 'more',
    addProduct: 'Add product',
    customerRank: 'Customer Rank',
    newRank: 'New',
    returningRank: 'Returning',
    regularRank: 'Regular',
    vipRank: 'VIP',
    eliteRank: 'Elite',
    margin: 'Margin',
    viewInvoice: 'Invoice',
    printInvoice: 'Print / Save PDF',
    ongoing: 'Ongoing',
    totalOrders: 'All Orders',
    address: 'Address',
    noNotes: 'No notes or attachments',
    unknownCustomer: 'Unknown Customer',
    generateInvoice: 'Generate Invoice',
    orderNotes: 'Order Notes',
    addNotesPlaceholder: 'Add notes...',
    viewAttachment: 'View Attachment',
    viewDocument: 'View Document',

    // Settings
    general: 'General',
    appearance: 'Appearance',
    stockSettings: 'Stock Settings',
    currency: 'Currency',
    language: 'Language',
    primaryColor: 'Primary Color',
    invoiceSettingsTitle: 'Invoice Settings',
    dataManagementTitle: 'Data Management & Integrations',
    dashboardSettingsTitle: 'Dashboard Settings',
    openInvoiceSettings: 'Open Invoice Settings',

    // Dashboard Chart Legends
    lowSales: 'low sales',
    averageSales: 'average',
    highSales: 'high sales',

    // Stock Adjustment Modal
    currentStock: 'Current Stock',
    change: 'Change',
    adjustedStock: 'Adjusted Stock',
    oilName: 'Oil',
    productImage: 'Product Image',
    oilQtyLabel: 'Oil Qty',

    // Filters
    filterByRank: 'Filter by Rank',
    allRanks: 'All Ranks',

    // Messages
    noOrdersFound: 'No orders found',
    noCustomersFound: 'No customers found',
    noProductsFound: 'No products found',
    noDeletedOrders: 'No deleted orders found.',

    // Low Stock Alert Modal
    belowThresholds: 'The following items are below their low stock thresholds:',
    threshold: 'Threshold',
    goToStock: 'Go to Stock',

    // Stock Management - Table Headers & Buttons
    productName: 'Product Name',
    category: 'Category',
    stock: 'Stock',
    cost: 'Cost',
    buildableStock: 'Buildable Stock',
    oil: 'Oil',
    oilQty: 'Oil Qty',
    price: 'Price',
    gender: 'Gender',
    totalCost: 'Total Cost',
    oilPerBottle: 'Oil per Bottle',
    oilType: 'Oil Type',
    pricePerMl: 'Price per ml',
    stockAvailable: 'Stock Available',
    unitCost: 'Unit Cost',
    stockMl: 'Stock (ml)',

    // Customers - Table Headers
    name: 'Name',
    mobile: 'Mobile',
    email: 'Email',
    state: 'State',
    city: 'City',
    rank: 'Rank',

    // Common Actions
    remove: 'Remove',
    removeItem: 'Remove Item',
    adjustStock: 'Adjust Stock',
    deleteItem: 'Delete Item',
    editItem: 'Edit Item',
    deleteOil: 'Delete Oil',
    deleteCustomer: 'Delete Customer',
    editCustomer: 'Edit Customer',
    editRole: 'Edit Role',
    deleteUser: 'Delete User',

    // Order Details Modal
    editOrder: 'Edit Order',
    orderDetails: 'Order Details',
    status: 'Status',
    date: 'Date',
    qty: 'Qty',
    package: 'Package',
    saveChanges: 'Save Changes',

    // Chart titles
    topSellingBottles: 'Top Selling Bottle Sizes',
    topCustomers: 'Top Customers',

    // Units
    units: 'units',
    ml: 'ml',

    // Login Page
    login: 'Login',
    password: 'Password',
    rememberMe: 'Remember me',
    loggingIn: 'Logging in…',
    signIn: 'Sign In',

    // Additional Stock Management
    size: 'Size',
    qtySold: 'Qty Sold',
    imageUrl: 'Image URL',
    id: 'ID',
    totalOrdered: 'Total Ordered',
    oilPerBottleML: 'Oil Per Bottle (ml)',
    addBottle: 'Add Bottle',
    addOil: 'Add Oil',
    quantity: 'Quantity',
    cannotSetStockBelowZero: 'Cannot set stock below zero',
    failedToUpdateStock: 'Failed to update stock',
    stockUpdated: 'Stock updated',
    userManagement: 'User Management',
    userManagementDesc: 'Manage user accounts and roles. Only admins can access this section.',
    userEmail: 'User Email',
    addUser: 'Add User',
    loadingUsers: 'Loading users...',
    email: 'Email',
    id: 'ID',
    createdAt: 'Created At',
    admin: 'Admin',
    user: 'User',
    editRole: 'Edit Role',
    deleteUser: 'Delete User',
    adding: 'Adding...',
    openInvoiceSettings: 'Open Invoice Settings',
    invoiceSettingsDesc: 'Configure your business identity and visual style for customer invoices.',
    dashboardSettingsDesc: 'Customize the layout and visibility of your main dashboard metrics.',
    showCard: 'Show Card',
    hideCard: 'Hide Card',
    storeName: 'Store Name',
    logoUrl: 'Logo URL',
    importAllData: 'Import All Data',
    exportAllData: 'Export All Data',

    // Rank Filter Options
    all: 'All',
    new: 'New',
    returning: 'Returning',
    regular: 'Regular',
    vip: 'VIP',
    elite: 'Elite',
    forHer: 'For Her',
    forher: 'For Her',
    forHim: 'For Him',
    forhim: 'For Him',
    testers: 'Testers',
    pockets: 'Pockets',
    to: 'To',
    apply: 'Apply',
    addAdsCost: 'Add Ads Cost',
    month: 'Month',
    amount: 'Amount',
    adsCostAdded: 'Ads cost added successfully.',
    order: 'Order',
    all: 'All',
    history: 'History',
    addCost: 'Add Cost',
    soldCompleted: 'Sold (Completed)',
    netRevenue: 'Monthly Revenue',
    grossProfit: 'Gross Profit',
    profitAfterAds: 'Profit After Ads',
    lowSales: 'Low Sales',
    averageSales: 'Average Sales',
    highSales: 'High Sales',
    viewAll: 'View All',
    lowStockAlerts: 'Low Stock Alerts',
    noLowStockAlerts: 'No low stock alerts',
    oilsThreshold: 'Oils (Below {threshold}ml)',
    bottlesThreshold: 'Bottles (Below {threshold} units)',
    critical: 'Critical',
    low: 'Low',
    remaining: 'remaining',
    threshold: 'Threshold',
    topSellingProducts: 'Top Selling Products',
    topSellingBottles: 'Top Selling Bottles',
    topCustomers: 'Top Customers',
    unisex: 'Unisex',
    testers: 'Testers',
    tester: 'Tester',
    storeIdentity: 'Store Identity',
    salesAndBilling: 'Sales & Billing',
    inventoryControl: 'Inventory Control',
    systemAndData: 'System & Data',
    teamManagement: 'Team Management',
    lowStockThresholds: 'Low Stock Thresholds',
    databaseConnection: 'Database (Supabase)',
    orderProcessing: 'Order Processing',
    appearance: 'Appearance',
    metricsVisibility: 'Metrics Visibility',
    importExport: 'Import / Export',
    securityWarning: 'Security Warning',
    securityWarningDesc: 'Storing Supabase keys in the browser is only recommended for admin convenience. In production, keys should be managed server-side.',
    invoiceIdentity: 'Invoice Identity',
    invoiceDesign: 'Invoice Design',
    showEmailOnInvoice: 'Show customer email on invoice',
    showCompanyNameOnInvoice: 'Show company name on invoice',
    bottleCategories: 'Bottle Categories',
    oilCategories: 'Oil Categories',
    addCategory: 'Add Category',
    newCategoryPlaceholder: 'New category (e.g., Premium)',
    newSizePlaceholder: 'New size (e.g., 50ml)',
    lowStockThresholdOils: 'Low Stock Threshold (Oils) (ml)',
    lowStockThresholdBottles: 'Low Stock Threshold (Bottles) (units)',
    inventoryLabels: 'Inventory Labels',
    inventoryLabelsDesc: 'Customize the names used throughout the app for your inventory items.',
    bottlesLabel: 'Bottles Label',
    oilsLabel: 'Oils Label',

    // New Customer Form
    addNewCustomer: 'Add New Customer',
    newCustomerTitle: 'New Customer',
    closeForm: 'Close Form',
    backToCustomers: 'Back to Customers',
    searchCity: 'Search City',
    typeToSearchCity: 'Type to search city...',
    useStateFirst: 'Use State First',
    selectState: 'Select a state',
    selectCity: 'Select a city',
    saveCustomer: 'Save Customer',
    checking: 'Checking...',
    addNewOil: 'Add New Oil',
    addNewBottle: 'Add New Bottle',
    oilName: 'Oil Name',
    pricePerMl: 'Price per ml',
    oilType: 'Oil Type',
    initialStock: 'Initial Stock',
    initialStockMl: 'Initial Stock (ml)',
    initialStockUnits: 'Initial Stock (units)',
    genderType: 'Gender/Type',
    selectGenderType: 'Select Gender/Type',
    selectSize: 'Select Size',
    generatedId: 'Generated ID',
    totalCostPerBottle: 'Total Cost per Bottle',
    oilPerBottleML: 'Oil Per Bottle (ml)',
    imageUrlOptional: 'Image URL (optional)',
    oilAddedSuccess: 'Oil added successfully',
    bottleAddedSuccess: 'Bottle added successfully',
    bottleExists: 'Bottle with this ID already exists!',

    // New Order Form
    newOrderTitle: 'New Order',
    backToBoard: 'Back to Board',
    customerDetails: 'Customer Details',
    searchByNameOrMobile: 'Search by name or mobile...',
    clearSearchTitle: 'Clear search',
    newButton: 'New',
    phone: 'Phone',
    shippingFee: 'Shipping Fee',
    cancelledBefore: 'Cancelled before',
    times: 'times',
    orderItems: 'Order Items',
    product: 'Product',
    used: 'Used',
    searchAndSelectProduct: 'Search and Select Product',
    available: 'Avail',
    usedBottle: 'Used Bottle',
    addProduct: 'Add Product',
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal',
    grandTotal: 'Grand Total',
    paymentMethod: 'Payment Method',
    cash: 'Cash',
    card: 'Card',
    orderDate: 'Order Date',
    createOrder: 'Create Order',

    // Search Placeholders
    searchByCustomerNameOrPhone: 'Search by customer name or phone...',
    searchProductNameOrOil: 'Search product name or oil...',

    // Shipping Table Headers
    shippingFeesColumn: 'Fees',
    editRule: 'Edit Rule',
    deleteRule: 'Delete Rule',

    // Additional Order Details Modal translations
    shippingDetails: 'Shipping Details',
    items: 'Items',
    cashPayment: 'Cash',
    visaPayment: 'Visa',
    usedAvailable: 'Used (Avail',
    newPackage: 'New',

    // Stock Management - Bottles & Oils tooltips
    deleteBottle: 'Delete Bottle',

    // New Order Form - Total & Profit
    finalOrderTotal: 'Final Order Total (Editable)',
    estProfit: 'Est. Profit (Order Total - COGS - Shipping)',

    // New Order Form - Additional
    netSale: 'Net Sale',
    totalsAndProfit: 'Totals & Profit',
    itemsSubtotal: 'Items Subtotal',
    orderNotesOptional: 'Order Notes (Optional)',
    specialInstructionsPlaceholder: 'Add any special instructions...',
    attachmentLabel: 'Attachment (Photo / File)',
    chooseTakePhoto: 'Choose / Take Photo',
    saveOrder: 'Save Order',
    addAnotherProduct: 'Add another product',

    // Dashboard - Additional
    history: 'History',
    addCost: 'Add Cost',
    critical: 'Critical',
    low: 'Low',
    remaining: 'remaining',
    viewAll: 'View All',

    // Order Actions - Short
    ship: 'Ship',
    deliver: 'Deliver',
    complete: 'Complete',
    return: 'Return',

    // Payment Methods
    cashLabel: 'Cash',
    visaLabel: 'Visa',

    // Stock Thresholds
    oilsThreshold: 'Oils (Threshold: {threshold} ml)',
    bottlesThreshold: 'Bottles (Threshold: {threshold} units)',
    item: 'Item',
    itemUpdated: 'Item updated.',
    selectOil: 'Select Oil',
    addNewState: '+ Add New State',
    enterNewStateName: 'Enter new state name',
  },

  ar: {
    // Common
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    add: 'إضافة',
    upload: 'رفع',
    search: 'بحث',
    actions: 'الإجراءات',
    close: 'إغلاق',
    confirm: 'تأكيد',
    back: 'رجوع',
    next: 'التالي',
    yes: 'نعم',
    no: 'لا',
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجح',
    generate: 'توليد',
    filters: 'الفلاتر',
    done: 'تم',
    profitMargin: 'هامش الربح',

    // Main Menu
    dashboard: 'لوحة التحكم',
    ordersBoard: 'لوحة الطلبات',
    stockManagement: 'إدارة المخزون',
    customersAndShipping: 'العملاء والشحن',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    leads: 'العملاء المحتملين',
    pendingWooOrders: 'طلبات ووكومرس المعلقة',
    unmappedClickToMap: 'غير محدد - اضغط للتحديد',
    ignored: 'تجاهل',
    existingCrmCustomer: 'عميل حالي في النظام',
    newCustomerLabel: 'عميل جديد',
    mapWooCommerceProduct: 'ربط منتج ووكومرس',
    selectCrmProductFor: 'اختر منتج النظام لـ:',
    typeToSearchCrmProducts: 'اكتب للبحث عن منتجات...',
    saveMapping: 'حفظ الربط',
    ignoreItem: 'تجاهل العنصر',
    importToCrm: 'استيراد للنظام',
    dismiss: 'تجاهل',
    noPendingWooOrders: 'لا توجد طلبات معلقة من ووكومرس.',
    newOrderFromWoo: 'طلب جديد من ووكومرس',

    // Orders Board
    deletedOrders: 'الطلبات المحذوفة',
    uploadOrders: 'رفع الطلبات',
    createNewOrder: 'إنشاء طلب جديد',
    newOrder: 'طلب جديد',
    revenue: 'الإيرادات',
    orderId: 'رقم الطلب',
    customer: 'العميل',
    location: 'الموقع',
    products: 'المنتجات',
    total: 'الإجمالي',
    payment: 'الدفع',
    shipping: 'الشحن',
    discount: 'الخصم',

    // Order Status
    ordered: 'مطلوب',
    shipped: 'تم الشحن',
    delivered: 'تم التوصيل',
    completed: 'مكتمل',
    cancelled: 'ملغي',
    returned: 'مرتجع',
    deleted: 'محذوف',

    // Order Actions
    moveToShipped: 'نقل إلى تم الشحن',
    moveToOrdered: 'نقل إلى مطلوب',
    moveToDelivered: 'نقل إلى تم التوصيل',
    completeSale: 'إتمام البيع',
    markReturned: 'تحديد كمرتجع',
    markCancelled: 'تحديد كملغي',
    reOrder: 'إعادة الطلب',
    softDelete: 'حذف مؤقت',
    restoreToCancelled: 'استعادة إلى ملغي',
    permanentlyDelete: 'حذف نهائي',
    cancelOrder: 'إلغاء الطلب',

    // Stock Management
    productsTab: 'المنتجات',
    bottles: 'الزجاجات',
    oils: 'الزيوت',
    returnedPool: 'المرتجعات',
    returnedProducts: 'المرتجعات',
    vendors: 'الموردين',
    vendorManagement: 'إدارة الموردين',
    vendorName: 'اسم المورد',
    selectVendor: 'اختر المورد',
    adsLedger: 'دفتر الإعلانات',
    addItem: 'إضافة عنصر',
    notifications: 'الإشعارات',
    uploadProducts: 'رفع المنتجات',
    uploadBottles: 'رفع الزجاجات',
    uploadOils: 'رفع الزيوت',
    selectProduct: 'اختر المنتج',
    addToReturned: 'إضافة للمرتجعات',

    // Customers & Shipping
    customers: 'العملاء',
    shippingFees: 'رسوم الشحن',
    newCustomer: 'عميل',
    addCity: 'إضافة مدينة',
    uploadCustomers: 'رفع العملاء',
    uploadShipping: 'رفع الشحن',
    fees: 'الرسوم',
    searchCustomer: 'ابحث عن اسم العميل أو رقم الجوال...',
    clearSearch: 'مسح البحث',

    // Dashboard
    totalOrders: 'جميع الطلبات',
    topSellingProducts: 'المنتجات الأكثر مبيعاً',
    lowStockAlert: 'تنبيه المخزون المنخفض',
    thisMonth: 'هذا الشهر',
    thisYear: 'هذا العام',
    allTime: 'كل الوقت',
    customRange: 'نطاق مخصص',
    from: 'من',
    totalRevenue: 'إجمالي الإيرادات',
    totalProfit: 'إجمالي الربح',
    profitMargin: 'هامش الربح',
    successfulOrders: 'الطلبات الناجحة',
    activeOrders: 'الطلبات النشطة',
    completedVisa: '(مكتمل + فيزا)',
    shippedRevenue: 'إيرادات الشحن',
    costOfGoods: 'تكلفة البضائع',
    soldCompleted: 'مباع/مكتمل',
    adsSpend: 'إنفاق الإعلانات',
    addAdsSpend: 'إضافة إنفاق إعلاني',
    grossProfit: 'إجمالي الربح',
    profitAfterAds: 'الربح بعد الإعلانات',
    lowStockAlerts: 'تنبيهات المخزون المنخفض',
    noLowStockAlerts: 'لا توجد تنبيهات مخزون منخفض!',
    netRevenue: 'الإيرادات الشهرية',

    // View Modes
    auto: 'تلقائي',
    table: 'جدول',
    cards: 'بطاقات',

    // Additional UI
    to: 'إلى',
    orders: 'طلبات',
    more: 'أكثر',
    addProduct: 'إضافة منتج',
    customerRank: 'رتبة العميل',
    newRank: 'جديد',
    returningRank: 'عائد',
    regularRank: 'منتظم',
    vipRank: 'مهم جدا',
    eliteRank: 'نخبة',
    margin: 'الهامش',
    viewInvoice: 'الفاتورة',
    printInvoice: 'طباعة / حفظ PDF',
    ongoing: 'جاري',
    totalOrders: 'جميع الطلبات',
    address: 'العنوان',
    noNotes: 'لا توجد ملاحظات أو مرفقات',
    unknownCustomer: 'عميل غير معروف',
    generateInvoice: 'إنشاء فاتورة',
    orderNotes: 'ملاحظات الطلب',
    addNotesPlaceholder: 'أضف ملاحظات...',
    viewAttachment: 'عرض المرفق',
    viewDocument: 'عرض المستند',

    // Settings
    general: 'عام',
    appearance: 'المظهر',
    stockSettings: 'إعدادات المخزون',
    currency: 'العملة',
    language: 'اللغة',
    primaryColor: 'اللون الأساسي',
    invoiceSettingsTitle: 'إعدادات الفاتورة',
    dataManagementTitle: 'إدارة البيانات والتكامل',
    dashboardSettingsTitle: 'إعدادات لوحة التحكم',
    openInvoiceSettings: 'فتح إعدادات الفاتورة',

    // Dashboard Chart Legends
    lowSales: 'مبيعات منخفضة',
    averageSales: 'متوسط',
    highSales: 'مبيعات عالية',

    // Stock Adjustment Modal
    currentStock: 'المخزون الحالي',
    change: 'التغيير',
    adjustedStock: 'المخزون المعدل',
    oilName: 'الزيت',
    productImage: 'صورة المنتج',
    oilQtyLabel: 'كمية الزيت',

    // Filters
    filterByRank: 'تصفية حسب الرتبة',
    allRanks: 'جميع الرتب',

    // Messages
    noOrdersFound: 'لم يتم العثور على طلبات',
    noCustomersFound: 'لم يتم العثور على عملاء',
    noProductsFound: 'لم يتم العثور على منتجات',
    noDeletedOrders: 'لم يتم العثور على طلبات محذوفة.',

    // Low Stock Alert Modal
    belowThresholds: 'العناصر التالية أقل من حد المخزون المنخفض:',
    threshold: 'الحد الأدنى',
    goToStock: 'الذهاب إلى المخزون',

    // Stock Management - Table Headers & Buttons
    productName: 'اسم المنتج',
    category: 'الفئة',
    stock: 'المخزون',
    cost: 'التكلفة',
    buildableStock: 'المخزون القابل للبناء',
    oil: 'الزيت',
    oilQty: 'كمية الزيت',
    price: 'السعر',
    gender: 'النوع',
    totalCost: 'التكلفة الإجمالية',
    oilPerBottle: 'الزيت لكل زجاجة',
    oilType: 'نوع الزيت',
    pricePerMl: 'السعر لكل مل',
    stockAvailable: 'المخزون المتاح',
    unitCost: 'تكلفة الوحدة',
    stockMl: 'المخزون (مل)',

    // Customers - Table Headers
    name: 'الاسم',
    mobile: 'الجوال',
    email: 'البريد الإلكتروني',
    state: 'المحافظة',
    city: 'المدينة',
    rank: 'الرتبة',

    // Common Actions
    remove: 'إزالة',
    removeItem: 'إزالة عنصر',
    adjustStock: 'تعديل المخزون',
    deleteItem: 'حذف العنصر',
    editItem: 'تعديل العنصر',
    deleteOil: 'حذف الزيت',
    deleteCustomer: 'حذف العميل',
    editCustomer: 'تعديل العميل',
    editRole: 'تعديل الدور',
    deleteUser: 'حذف المستخدم',

    // Order Details Modal
    editOrder: 'تعديل الطلب',
    orderDetails: 'تفاصيل الطلب',
    status: 'الحالة',
    date: 'التاريخ',
    qty: 'الكمية',
    package: 'الحزمة',
    saveChanges: 'حفظ التغييرات',

    // Chart titles
    topSellingBottles: 'أحجام الزجاجات الأكثر مبيعاً',
    topCustomers: 'أفضل العملاء',

    // Units
    units: 'وحدات',
    ml: 'مل',

    // Login Page
    login: 'تسجيل الدخول',
    password: 'كلمة المرور',
    rememberMe: 'تذكرني',
    loggingIn: 'جاري تسجيل الدخول…',
    signIn: 'تسجيل الدخول',

    // Additional Stock Management
    size: 'الحجم',
    qtySold: 'الكمية المباعة',
    imageUrl: 'رابط الصورة',
    id: 'المعرف',
    totalOrdered: 'إجمالي الطلبات',
    oilPerBottleML: 'الزيت لكل زجاجة (مل)',
    addBottle: 'إضافة زجاجة',
    addOil: 'إضافة زيت',
    quantity: 'الكمية',
    cannotSetStockBelowZero: 'لا يمكن تعيين المخزون أقل من صفر',
    failedToUpdateStock: 'فشل تحديث المخزون',
    stockUpdated: 'تم تحديث المخزون',
    userManagement: 'إدارة المستخدمين',
    userManagementDesc: 'إدارة حسابات المستخدمين والأدوار. يمكن للمشرفين فقط الوصول إلى هذا القسم.',
    userEmail: 'بريد المستخدم الإلكتروني',
    addUser: 'إضافة مستخدم',
    loadingUsers: 'جاري تحميل المستخدمين...',
    email: 'البريد الإلكتروني',
    id: 'المعرف',
    createdAt: 'أنشئ في',
    admin: 'مشرف',
    user: 'مستخدم',
    editRole: 'تعديل الدور',
    deleteUser: 'حذف المستخدم',
    adding: 'جاري الإضافة...',
    openInvoiceSettings: 'فتح إعدادات الفاتورة',
    invoiceSettingsDesc: 'تكوين هوية عملك والنمط المرئي لفواتير العملاء.',
    dashboardSettingsDesc: 'تخصص تخطيط وظهور مقاييس لوحة القيادة الرئيسية الخاصة بك.',
    showCard: 'إظهار البطاقة',
    hideCard: 'إخفاء البطاقة',
    storeName: 'اسم المتجر',
    logoUrl: 'رابط الشعار',
    importAllData: 'استيراد جميع البيانات',
    exportAllData: 'تصدير جميع البيانات',

    // Rank Filter Options
    all: 'الكل',
    new: 'جديد',
    returning: 'عائد',
    regular: 'منتظم',
    vip: 'مميز',
    elite: 'نخبة',
    forHer: 'نسائي',
    forher: 'نسائي',
    forHim: 'رجالي',
    forhim: 'رجالي',
    testers: 'عينات',
    pockets: 'بوكيت',
    to: 'إلى',
    apply: 'تطبيق',
    addAdsCost: 'إضافة تكلفة إعلانات',
    month: 'الشهر',
    amount: 'المبلغ',
    adsCostAdded: 'تمت إضافة تكلفة الإعلانات بنجاح.',
    order: 'طلب',
    all: 'الكل',
    history: 'السجل',
    addCost: 'إضافة تكلفة',
    soldCompleted: 'بيعت (مكتملة)',
    netRevenue: 'الإيرادات الشهرية',
    grossProfit: 'إجمالي الربح',
    profitAfterAds: 'الربح بعد الإعلانات',
    lowSales: 'مبيعات منخفضة',
    averageSales: 'مبيعات متوسطة',
    highSales: 'مبيعات عالية',
    viewAll: 'عرض الكل',
    lowStockAlerts: 'تنبيهات انخفاض المخزون',
    noLowStockAlerts: 'لا توجد تنبيهات انخفاض مخزون',
    oilsThreshold: 'الزيوت (أقل من {threshold} مل)',
    bottlesThreshold: 'الزجاجات (أقل من {threshold} وحدة)',
    critical: 'حرج',
    low: 'منخفض',
    remaining: 'متبقي',
    threshold: 'الحد الأدنى',
    topSellingProducts: 'أكثر المنتجات مبيعاً',
    topSellingBottles: 'أكثر الزجاجات مبيعاً',
    topCustomers: 'كبار العملاء',
    unisex: 'يونسكس',
    testers: 'عينات',
    tester: 'تيستر',
    storeIdentity: 'هوية المتجر',
    salesAndBilling: 'المبيعات والفواتير',
    inventoryControl: 'التحكم في المخزون',
    systemAndData: 'النظام والبيانات',
    teamManagement: 'إدارة الفريق',
    lowStockThresholds: 'حدود انخفاض المخزون',
    databaseConnection: 'قاعدة البيانات (Supabase)',
    orderProcessing: 'معالجة الطلبات',
    appearance: 'المظهر',
    metricsVisibility: 'رؤية المقاييس',
    importExport: 'الاستيراد والتصدير',
    securityWarning: 'تحذير أمني',
    securityWarningDesc: 'تخزين مفاتيح Supabase في المتصفح مخصص لراحة المشرفين فقط. في بيئة العمل الفعلية، يجب إدارة المفاتيح من طرف الخادم.',
    invoiceIdentity: 'هوية الفاتورة',
    invoiceDesign: 'تصميم الفاتورة',
    showEmailOnInvoice: 'عرض بريد العميل على الفاتورة',
    showCompanyNameOnInvoice: 'عرض اسم الشركة على الفاتورة',
    bottleCategories: 'فئات الزجاجات',
    oilCategories: 'فئات الزيوت',
    addCategory: 'إضافة فئة',
    newCategoryPlaceholder: 'فئة جديدة (مثلاً: ممتاز)',
    newSizePlaceholder: 'حجم جديد (مثلاً: 50 مل)',
    lowStockThresholdOils: 'حد انخفاض مخزون الزيوت (مل)',
    lowStockThresholdBottles: 'حد انخفاض مخزون الزجاجات (وحدة)',
    inventoryLabels: 'تسميات المخزون',
    inventoryLabelsDesc: 'تخصيص الأسماء المستخدمة في التطبيق لعناصر المخزون الخاصة بك.',
    bottlesLabel: 'تسمية الزجاجات',
    oilsLabel: 'تسمية الزيوت',

    // New Customer Form
    addNewCustomer: 'إضافة عميل جديد',
    newCustomerTitle: 'عميل جديد',
    closeForm: 'إإغلاق النموذج',
    backToCustomers: 'العودة إلى العملاء',
    searchCity: 'البحث عن مدينة',
    typeToSearchCity: 'اكتب للبحث عن مدينة...',
    useStateFirst: 'استخدم المحافظة أولاً',
    selectState: 'اختر محافظة',
    selectCity: 'اختر مدينة',
    saveCustomer: 'حفظ العميل',
    checking: 'جاري التحقق...',
    addNewOil: 'إضافة زيت جديد',
    addNewBottle: 'إضافة زجاجة جديدة',
    oilName: 'اسم الزيت',
    pricePerMl: 'السعر لكل مل',
    oilType: 'نوع الزيت',
    initialStock: 'المخزون الأولي',
    initialStockMl: 'المخزون الأولي (مل)',
    initialStockUnits: 'المخزون الأولي (وحدة)',
    genderType: 'النوع',
    selectGenderType: 'اختر النوع',
    selectSize: 'اختر الحجم',
    generatedId: 'المعرف المولد',
    totalCostPerBottle: 'إجمالي التكلفة للزجاجة',
    oilPerBottleML: 'الزيت لكل زجاجة (مل)',
    imageUrlOptional: 'رابط الصورة (اختياري)',
    oilAddedSuccess: 'تم إضافة الزيت بنجاح',
    bottleAddedSuccess: 'تم إضافة الزجاجة بنجاح',
    bottleExists: 'الزجاجة بهذا المعرف موجودة بالفعل!',

    // New Order Form
    newOrderTitle: 'طلب جديد',
    backToBoard: 'العودة إلى اللوحة',
    customerDetails: 'تفاصيل العميل',
    searchByNameOrMobile: 'ابحث بالاسم أو رقم الجوال...',
    clearSearchTitle: 'مسح البحث',
    newButton: 'جديد',
    phone: 'الهاتف',
    shippingFee: 'رسوم الشحن',
    cancelledBefore: 'ألغى من قبل',
    times: 'مرات',
    orderItems: 'عناصر الطلب',
    product: 'المنتج',
    used: 'مستعمل',
    searchAndSelectProduct: 'ابحث واختر المنتج',
    available: 'متاح',
    usedBottle: 'زجاجة مستعملة',
    addProduct: 'إضافة منتج',
    orderSummary: 'ملخص الطلب',
    subtotal: 'المجموع الفرعي',
    grandTotal: 'المجموع الإجمالي',
    paymentMethod: 'طريقة الدفع',
    cash: 'نقدي',
    card: 'بطاقة',
    orderDate: 'تاريخ الطلب',
    createOrder: 'إنشاء طلب',

    // Search Placeholders
    searchByCustomerNameOrPhone: 'ابحث باسم العميل أو رقم الهاتف...',
    searchProductNameOrOil: 'ابحث عن اسم المنتج أو الزيت...',

    // Shipping Table Headers
    shippingFeesColumn: 'الرسوم',
    editRule: 'تعديل القاعدة',
    deleteRule: 'حذف القاعدة',

    // Additional Order Details Modal translations
    shippingDetails: 'تفاصيل الشحن',
    items: 'العناصر',
    cashPayment: 'نقدي',
    visaPayment: 'فيزا',
    usedAvailable: 'مستعمل (متاح',
    newPackage: 'جديد',

    // Stock Management - Bottles & Oils tooltips
    deleteBottle: 'حذف الزجاجة',

    // New Order Form - Total & Profit
    finalOrderTotal: 'إجمالي الطلب النهائي (قابل للتعديل)',
    estProfit: 'الربح المتوقع (إجمالي الطلب - التكلفة - الشحن)',

    // New Order Form - Additional
    netSale: 'صافي البيع',
    totalsAndProfit: 'المجموع والربح',
    itemsSubtotal: 'المجموع الفرعي للعناصر',
    orderNotesOptional: 'ملاحظات الطلب (اختياري)',
    specialInstructionsPlaceholder: 'أضف أي تعليمات خاصة...',
    attachmentLabel: 'مرفق (صورة / ملف)',
    chooseTakePhoto: 'اختر / التقط صورة',
    saveOrder: 'حفظ الطلب',
    addAnotherProduct: 'إضافة منتج آخر',

    // Dashboard - Additional
    history: 'السجل',
    addCost: 'إضافة تكلفة',
    critical: 'حرج',
    low: 'منخفض',
    remaining: 'متبقي',
    viewAll: 'عرض الكل',

    // Order Actions - Short
    ship: 'شحن',
    deliver: 'توصيل',
    complete: 'إتمام',
    return: 'إرجاع',

    // Payment Methods
    cashLabel: 'نقدي',
    visaLabel: 'فيزا',

    // Stock Thresholds
    oilsThreshold: 'زيوت (الحد: {threshold} مل)',
    bottlesThreshold: 'زجاجات (الحد: {threshold} وحدة)',
    item: 'عنصر',
    itemUpdated: 'تم تحديث العنصر.',
    selectOil: 'اختر الزيت',
    addNewState: '+ إضافة محافظة جديدة',
    enterNewStateName: 'أدخل اسم المحافظة الجديدة',
  },
};
